module.exports = {
  home:                         'Übersicht',
  channels:                     'Channels',
  lastChannelUpdates:           'Last Channel Updates',
  topics:                       'Topics',
  noTitle:                      'No title',
  noDescription:                'No description found',
  imageMap:                     'Image map',
  de:                           'deutsch',
  en:                           'english',
  contact:                      'Contact',
  imprint:                      'Imprint',
  legal:                        'Legal',
  downloads:                    'Download',
  downloadTitle:                'Download video:',
  downloadDescription:          '',
  directLinks:                  'Link',
  directLinkTitle:              'Video link',
  directLinkDescription:        '',
  shortlink:                    'Shortlink',
  //
  browseCategories:             'Select category',
  //
  prepareDownload:              'Preparing download...',
  //
  contactPerson:                'Contact person',
  contactCompany:               'Company',
  contactOccupation:            'Occupation',
  contactPhone:                 'Phone',
  contactEmail:                 'E-mail',
  mediahubTechError:            'An error occurred while we tried to display this page. Please contact the person who have sent you this link.',
  mediahubNotYetAvailable:      'This page is not yet available. Please visit this page again on ',
  mediahubNoLongerAvailable:    'This page is not available since ',
  mediahubMaxDownloads:         'The maximum number of requests for this page is reached.',
  zoomTurnedOff:                'Enable image zoom',
  zoomTurnedOn:                 'Disable image zoom',
  //additional information
  additionalMedia:              'Additional downloads',
  additionalMediaContainer:     'More Videos about',
  moreVideos:                   'More videos',
  start:                        'Available from:',
  end:                          'to:',
  //authentication
  authenticationRequired:       'Authentication required to access this page.',
  authUsername:                 'Username',
  authPassword:                 'Password',
  authLogin:                    'Login',
  authWrong:                    'Wrong authentication. Please try again.',
  //videorelated
  videoSize:                    'Size',
  fileSize:                     'File size',
  formatDownloads:              'Download formats',
  download:                     'Download',
  mediaNotAvailable:            'Video is not available for download.',
  // QualityOfVideo
  hd:                           'HD',
  timeout:                      'The page has timed out.',
  timeoutDescription:           'For security reasons this page was only valid for a certain amount of time. Please use your browser\'s refresh button to go back to the page.',
  noDataForMediaHub:            'No media files present',
  noDataForMediaHubDescription: 'There are no media files connected with this mediahub.',
  mediahub:                     'MediaHub',
  loading:                      '...loading',
  //media
  title:                        'Title',
  description:                  'Description',
  videoDescription:             'Description',
  mediaDescription:             'Description',
  // search
  search:                       'Search',
  searchResults:                'Results',
  // Player Overlay
  playerOverlayViews:           'Views:',
  playerOverlayDate:            'Date:',
  playerOverlayTags:            'Tags:',
  // Breadcrumb
  breadcrumbYouAreHere:         'You are here:',
  breadCrumbHomepage:           'Homepage',
  breadCrumbSlider:             'In slider',
  // Errors
  unauthorized:                 '401 - Unauthorized',
  forbidden:                    '403 - Forbidden',
  notFound:                     '404 - Publicarea could not be found.',
  serverError:                  '500 - Internal server error',
  error404p1:                   'The page you are looking for could not be found.',
  error404p2:                   'Please check the address.',
  error404p3:                   'For more information please contact us ',
  error404contact:              'here',
  //empty
  emptyString:                  ' ',
  backToOverview:               'Back to Overview',
  showAll:                      'Show all',
  showMore:                     'Show more videos',
  all:                          'All',
  filter_countEmbeds:           'Most viewed videos',
  filter_createdAt:             'Latest videos',
  filter_publishedDate:         'Latest videos',
  noCreationDate:               'No creation date',
  video:                        'Videos',
  watchVideo:                  'Watch video',
  sharePost:                    'Share this video',

};



// WEBPACK FOOTER //
// ./src/stores/i18n/en.js